import './LiveHistory.sass';

import React, { FC, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { LiveHistoryProps } from '$core/Live/LiveHistory/LiveHistory.interface';
import { LiveHistoryMsg } from '$core/Live/LiveHistoryMsg/LiveHistoryMsg';
import { useSelector } from 'react-redux';
import { liveSelector } from '$store/live';
import { ScrollView } from '$uikit';
import { scrollToBottom, scrollToBottomWithCheck } from '$utils';
import { AttachType, CurrencyEnum, StreamMessageModelType } from '$store/models';
import { Currency } from '$shared/components';
import { LiveHistoryFilterEnum, LiveType } from '$store/live/interface';
import { useTranslator } from '$hooks';

export const LiveHistory: FC<LiveHistoryProps> = ({ onMsgClick }) => {
  const t = useTranslator();
  const { messages, allMessagesLoaded, historyFilter, sponsors, type, focus } =
    useSelector(liveSelector);
  const firstRender = useRef(true);

  useEffect(() => {
    if (!allMessagesLoaded || firstRender.current) {
      scrollToBottom('live_history');
    } else {
      scrollToBottomWithCheck('live_history');
    }
    firstRender.current = false;
  }, [allMessagesLoaded, messages]);

  useEffect(() => {
    scrollToBottom('live_history');
  }, [historyFilter]);

  const filteredMessages = useMemo(() => {
    return type === LiveType.PUBLISHER
      ? messages.filter((msg) => {
          if (historyFilter === LiveHistoryFilterEnum.ALL) {
            return true;
          } else if (historyFilter === LiveHistoryFilterEnum.TIPS) {
            return !!msg.attachments.find((a) => a.type === AttachType.TIPS);
          } else if (historyFilter === LiveHistoryFilterEnum.SPONSORS) {
            return sponsors[msg.fromId];
          }
          return false;
        })
      : messages;
  }, [historyFilter, sponsors, messages, type]);

  return (
    <div className="LiveHistory">
      <ScrollView id="live_history" isReversedDirection>
        <div className="LiveHistory__messages">
          {filteredMessages.map((msg) => {
            const tips = msg.attachments.find((a) => a.type === AttachType.TIPS);
            return (
              <LiveHistoryMsg
                onClick={onMsgClick && !focus ? (m) => onMsgClick(msg, m) : undefined}
                sponsor={sponsors[msg.fromId]}
                info={
                  tips ? (
                    <Currency
                      amount={tips.tips?.amount || 0}
                      currency={CurrencyEnum.EUR}
                    />
                  ) : msg.type &&
                    msg.type !== StreamMessageModelType.StreamMessageText ? (
                    t('live_history_type_' + msg.type)
                  ) : undefined
                }
                key={msg.id}
                marked={!!tips}
                pending={msg.id < 0}
                userId={msg.fromId}
                message={
                  msg.type == StreamMessageModelType.StreamMessageText
                    ? msg.text
                    : undefined
                }
              />
            );
          })}
        </div>
      </ScrollView>
    </div>
  );
};
